import type { HelpContent } from '../types'

/**
 * Help panel + first-run walkthrough copy for Settings. Em-dash free.
 * Note: the Safety tab is described generically as "which workflows run" on
 * purpose. Do not name specific pre-outreach viewing/liking behavior here.
 */
export const SETTINGS_HELP: HelpContent = {
  key: 'settings',
  title: 'Settings',
  intro:
    'Settings is where you set up how your outreach works: connect LinkedIn, describe who you target and what you offer, tune your messaging and safety limits, and manage your account. Fill these in before launching a campaign.',
  panel: [
    {
      heading: 'Do this first',
      items: [
        {
          text: 'Connect LinkedIn under the LinkedIn tab. Leads, Campaigns, Content, and Inbox stay locked until you do.',
        },
      ],
    },
    {
      heading: 'The core setup',
      items: [
        { term: 'ICP', text: 'Your ideal customer profile: the titles, industries, sizes, and locations you target. Discovery uses it to find leads.' },
        { term: 'Offer', text: 'What you sell, the pains you solve, and proof points the AI cites when it pitches.' },
        { term: 'Messaging', text: 'Your tone, a sample message in your voice, rate limits, and follow-up timing.' },
        { term: 'Call to action', text: 'The goal and link the AI sends when a lead is ready to book.' },
      ],
    },
    {
      heading: 'Answers the AI uses',
      items: [
        { term: 'FAQ', text: 'Questions leads ask and your exact answers. Used when a lead replies with a question.' },
        { term: 'Objections', text: 'Pushback leads raise and how you want the AI to respond.' },
      ],
    },
    {
      heading: 'Safety and account',
      items: [
        { term: 'Safety', text: 'Daily limits and which workflows run, to keep your LinkedIn account safe.' },
        { term: 'Account', text: 'Your plan, billing, and account deletion.' },
      ],
    },
    {
      heading: 'Good to know',
      items: [
        { text: 'Voice and the content settings are Pro features and appear dimmed on the Basic plan.' },
        { text: 'Most fields have a question mark next to them with a short explainer.' },
      ],
    },
  ],
  tour: [
    {
      id: 'welcome',
      title: 'Set up your outreach',
      body: 'Settings controls how your automation targets, writes, and paces itself. Fill it in before launching a campaign.',
    },
    {
      id: 'tabs',
      target: 'settings-tabs',
      title: 'Everything is in these tabs',
      body: 'Connect LinkedIn first, then set your targeting, offer, messaging, and safety limits.',
    },
    {
      id: 'done',
      title: 'You are set',
      body: 'Each field has a question mark with a short explainer. Reopen this walkthrough anytime from the Help button.',
    },
  ],
}
